import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="app-footer">
      <p>
        Originally made for friends. Just for fun.
      </p>
    </footer>
  );
};

export default Footer;


